import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { ChartRisk } from "@/shared/types/chart-risk";

import { LINE_CHART_MARGIN_PARAMS_PX } from "../constants";
import { ChartWrapper } from "../styled/chart-wrapper";
import { getChartDataByUsingInterval } from "../utils/get-chart-data-by-using-interval";

const INTERVAL_COUNT = 1000;
interface Props {
  data?: ChartRisk["simulatedVolatilityHistogram"];
}

export const SimulatedVolatilityChart: React.FC<Props> = ({ data }) => {
  const finish = Math.max(...(data?.values || []));
  const start = Math.min(...(data?.values || []));

  const { chartData } = getChartDataByUsingInterval({
    start,
    finish,
    intervalCount: INTERVAL_COUNT,
    list: data?.values || [],
  });

  return (
    <ChartWrapper>
      <ResponsiveContainer>
        <BarChart data={chartData} margin={LINE_CHART_MARGIN_PARAMS_PX}>
          <XAxis dataKey="value" />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <YAxis dataKey="amount" />
          <Bar dataKey="amount" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
};
